export const leftPaddleId: string = "LeftPaddle";

export const rightPaddleId: string = "RightPaddle";

export const leftPaddleSelector: string = `button[data-unique-id='${leftPaddleId}']`;

export const rightPaddleSelector: string = `button[data-unique-id='${rightPaddleId}']`;
